import XHRPromise from 'xhr-promise'
import Helpers from '../modules/Helpers'
import Slider from '../modules/Slider'

const resultsItemsContainer = document.getElementsByClassName('results-list__items')
const imageGroupSelector = '.results-list__item-image-group'

const loadImages = imageGroup => new Promise((resolve) => {
    
    const resultItem = new Helpers(imageGroup).getClosest('[data-code^="C"][data-year]');
    const code = resultItem.getAttribute('data-code');
    const year = resultItem.getAttribute('data-year');
    const count = 5;
    const xhr = new XHRPromise();

    xhr.send({
        url: `/feeds/cottageListPics.aspx?code=${code}&year=${year}&count=${count}&context=search`,
    })
        .then(response => (new window.DOMParser()).parseFromString(response.responseText, 'text/xml'))
        .then((data) => {
            
            const pictures = Array.from(data.getElementsByTagName('picture'));  
            const pictureInfo = data.getElementsByTagName('pictures')[0];
            const fullyGalleryLength = pictureInfo.getAttribute('unrestrictedGalleryLength');

            pictures.forEach((p, index) => {
                const sliderItem = document.createElement('div');
                const highLightSlide = index === pictures.length-1 && fullyGalleryLength > count+1;
                const classList = highLightSlide ? 'slider__item highlight' : 'slider__item';
                sliderItem.setAttribute('class', classList);

                if(highLightSlide) {
                    const link = document.createElement('a');
                    const cottageURL = pictureInfo.getAttribute('url');
                    link.setAttribute('href', cottageURL);
                    link.innerHTML = `<span>View ${fullyGalleryLength - count}<br/>more images</span>`;
                    sliderItem.appendChild(link); 
                }

                const img = document.createElement('img');
                img.setAttribute('src', p.getAttribute('url'));
                img.setAttribute('srcset', p.getAttribute('srcsets'));
                img.setAttribute('sizes', p.getAttribute('sizes'));
                sliderItem.appendChild(img);
                imageGroup.getElementsByClassName('slides__container')[0].appendChild(sliderItem);
            })

            imageGroup.getElementsByClassName('slides__container')[0].style.width = '999999px';
            const slider = new Slider(imageGroup);
            new Helpers(imageGroup).removeClass('slider--inactive').addClass('slider')
            resolve(slider)
        })
})

if (resultsItemsContainer.length > 0) {
    new Helpers(resultsItemsContainer).delegateEventListener(imageGroupSelector, (e) => {
        const el = new Helpers(e.target).getClosest(imageGroupSelector)
        if (el.getAttribute('data-loaded') !== 'true') {
            // set as loaded
            el.setAttribute('data-loaded', 'true')
            // get images and load swiper
            loadImages(el)
        }
    }, 'mouseover')

    new Helpers(resultsItemsContainer).delegateEventListener(imageGroupSelector, (e) => {
        const el = new Helpers(e.target).getClosest(imageGroupSelector)
        if (el.getAttribute('data-loaded') !== 'true') {
            const touchStart = e.touches[0].pageX
            // set as loaded
            el.setAttribute('data-loaded', 'true')
            // get images and load swiper
            let slider = null
            // load the images and retrieve instance
            loadImages(el).then((sliderInstance) => {
                slider = sliderInstance
            })

            // register a one off touchend event to perform the first navigation event
            const touchendCallback = (event) => {
                event.currentTarget.removeEventListener(event.type, touchendCallback)
                const touchEnd = event.changedTouches[0].pageX
                const touchChange = touchStart - touchEnd
                // if there is sufficient positional change, navigate the slider
                if (Math.abs(touchChange) > 30) {
                    // use an interval timer as the slider may not yet have been initialized
                    const sliderNavigateOnLoad = setInterval(() => {
                        if (slider !== null) {
                            clearInterval(sliderNavigateOnLoad)
                            if (touchChange > 30) slider.changeSlide('next', slider.isLoop())
                            if (touchChange < -30) slider.changeSlide('prev', slider.isLoop())
                        }
                    }, 50)
                }
            }

            el.addEventListener('touchend', touchendCallback)
        }
    }, 'touchstart')
}
